import React, { useMemo, useState } from 'react';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Typography, TextField, IconButton, Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

// Lightweight patient list scoped to a Care Provider
export default function CareProviderPatientList({ careProvider, profiles = [], onClose }) {
  const [search, setSearch] = useState('');

  const patients = useMemo(() => {
    if (!careProvider) return [];
    return profiles.filter(p => {
      try {
        if (p.care_provider && (p.care_provider.id === careProvider.id || p.care_provider === careProvider.id)) return true;
        if (p.profile && (p.profile.care_provider === careProvider.id || (p.profile.care_provider && p.profile.care_provider.id === careProvider.id))) return true;
        if (p.assigned_care_provider_id && p.assigned_care_provider_id === careProvider.id) return true;
        return false;
      } catch (e) { return false; }
    }).filter(p => {
      if (!search) return true;
      const name = `${p.first_name || p.firstName || ''} ${p.last_name || p.lastName || ''}`.toLowerCase();
      return name.includes(search.toLowerCase()) || (p.email || '').toLowerCase().includes(search.toLowerCase());
    });
  }, [careProvider, profiles, search]);

  return (
    <div>
      <Paper style={{ padding: 12, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 12 }}>
        <IconButton onClick={onClose} aria-label="back"><ArrowBackIcon/></IconButton>
        <div style={{ flex: 1 }}>
          <Typography variant="h6">Patients assigned to: {careProvider?.name_business || careProvider?.name || ''}</Typography>
          <Typography variant="body2" color="textSecondary">{patients.length} patients</Typography>
        </div>
        <TextField size="small" variant="outlined" placeholder="Search patients" value={search} onChange={e => setSearch(e.target.value)} />
      </Paper>

      <Paper style={{ padding: 8 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><b>Patient</b></TableCell>
              <TableCell><b>Email</b></TableCell>
              <TableCell><b>Diagnosis</b></TableCell>
              <TableCell><b>Progress</b></TableCell>
              <TableCell><b>Pain</b></TableCell>
              <TableCell><b>Function</b></TableCell>
              <TableCell><b>NPS</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {patients.map(p => (
              <TableRow key={p.user_id || p.id || (p.user && p.user.id)}>
                <TableCell>{p.first_name || p.firstName || ''} {p.last_name || p.lastName || ''}</TableCell>
                <TableCell>{p.email || ''}</TableCell>
                <TableCell>{(p.diagnosis && p.diagnosis.length) ? p.diagnosis.map(d => d.title).join(', ') : '-'}</TableCell>
                <TableCell>{(p.diagnosis && p.diagnosis.length) ? `${p.diagnosis[0].progress || '-'}%` : '-'}</TableCell>
                <TableCell>{(p._metrics && p._metrics.baseline_payload) ? (p._metrics.baseline_payload.selfRatedPain || '-') : '-'}</TableCell>
                <TableCell>{(p._metrics && p._metrics.latest_function !== undefined && p._metrics.latest_function !== null) ? p._metrics.latest_function : '-'}</TableCell>
                <TableCell>{(p._metrics && p._metrics.baseline_payload) ? (p._metrics.baseline_payload.selfRatedNPS || '-') : '-'}</TableCell>
              </TableRow>
            ))}
            {patients.length === 0 && (
              <TableRow><TableCell colSpan={7}><Typography variant="body2">No patients assigned to this care provider.</Typography></TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
}
